import { Button } from '@fluentui/react-components';
import { PersonSwapRegular } from '@fluentui/react-icons';
import { useAuth } from '../auth/TeamsAuthProvider';

// The "View As" button for PageHeader's `actions` slot (spec §4.1, §4.2:
// "the emulation banner stays global"). PageHeader itself gates rendering of
// `actions` to platform/tenant admins via `hasEmulationAccess`, so every
// caller can pass this unconditionally.
//
// Extracted so every route wires the same button instead of duplicating the
// nine near-identical copies that existed across SlimBrandHeader and each
// page before this PR.

interface ViewAsActionProps {
  /** Whether the "View As" emulation panel is currently open. */
  emulationPanelOpen: boolean;
  /** Toggles the emulation panel; the panel itself is rendered by PlatformEmulationControl. */
  onToggleEmulationPanel: () => void;
}

export function ViewAsAction({ emulationPanelOpen, onToggleEmulationPanel }: ViewAsActionProps) {
  const { user } = useAuth();
  return (
    <Button
      data-testid="platform-emulation-toggle"
      size="small"
      appearance="subtle"
      icon={<PersonSwapRegular />}
      aria-pressed={emulationPanelOpen}
      onClick={onToggleEmulationPanel}
    >
      {user?.is_emulating ? 'Change View As' : 'View As'}
    </Button>
  );
}
